<template>
  <div id="listContent" class="listContent headForm">
    <a-form :form="form" class="ant-advanced-search-form" labelAlign="left">
      <a-row :gutter="24">
        <!-- 基础信息 -->
        <a-col :span="2">
          <a-form-item label="基础信息：">
            <div class="form-text-info"></div>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="动物类型">
            <animal-select style="width: 100%" v-decorator="['animalTypeCode']"/>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="线路">
            <a-select allowClear v-decorator="['lineId', { rules: [{ required: false, message: '选择线路' }] }]" placeholder="选择线路">
              <a-select-option v-for="el in lineList" :key="el.id" :value="el.id">
                {{ el.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="配方类型">
            <a-select size="small" placeholder="全部配方" v-decorator="['formulaType']" style="width: 100%">
              <a-select-option v-for="i in [{name:'全部配方',value: '0'},{name:'配合饲料',value: '1'},{name:'混合日粮',value: '2'}]" :key="i.value">
                {{ i.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="配方分类">
            <a-select allowClear v-decorator="['typeClassify']" style="width: 100%" placeholder="配方分类">
           <a-select-option :value="0"> 未分类 </a-select-option>
            <a-select-option :value="1"> 自产配方 </a-select-option>
            <a-select-option :value="2"> 代工配方 </a-select-option>
            <a-select-option :value="3"> 定制配方 </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <!-- 配方相关 -->
        <a-col :span="2">
          <a-form-item label='配方相关：'>
            <div class="form-text-info"></div>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="配方">
            <a-input style="width: 100%" @pressEnter="getListHandle" v-decorator="['formulaKeyword']" placeholder="请输入配方名称或代码"/>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="指标" style="height: 40px;">
            <a-select
                allowClear
                show-search
                placeholder="请输入指标名称或代码"
                style="width: 100%;overflow: auto;margin-top: 9px;height: 24px;"
                size='small'
                :default-active-first-option="false"
                :filter-option="false"
                :not-found-content="null"
                @search="getSearchList"
                @select="onSelect"
                v-decorator="['nutritionIds']"
                @inputKeydown='inputKeydown'
            >
              <a-select-option v-for="d in searchList" :key="d.id">
                {{ d.firstName }}<span style="color: red">{{ d.midName }}</span>{{ d.lastName }}({{ d.code }})
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="版本状态">
            <a-select v-decorator="['isActivate']" style="width: 100%">
              <a-select-option value="1">激活版本</a-select-option>
              <a-select-option value="0">全部版本</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="2">
          <a-form-item>
            <div class="form-text-info"></div>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="是否推送">
            <a-select v-decorator="['isPushEbs']" style="width: 100%" placeholder="请选择推送状态" allowClear>
              <a-select-option :value="1">是</a-select-option>
              <a-select-option :value="0">否</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="推送日期">
            <a-range-picker v-decorator="['pushDateRange']" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="生成日期">
            <a-range-picker v-decorator="['createDateRange']" style="width: 100%" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <!-- 组织架构 -->
        <a-col :span="2">
          <a-form-item label="组织架构：">
            <div class="form-text-info"></div>
          </a-form-item>
        </a-col>
        <a-col :span="7">
          <a-form-item label="工厂">
            <!-- <a-input style="width: 100%" @pressEnter="getListHandle" v-decorator="['factoryKeyword']" placeholder="请输入工厂" /> -->
            <a-select
                placeholder="请选择工厂"
                size='small'
                v-decorator="['factoryIds']"
                mode="multiple"
                :max-tag-count="1"
                :showArrow="true"
            >
              <a-select-option v-for="i in factoryList" :key="i.factoryId">
                {{ i.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <!-- 操作 -->
        <a-col :span="2">
          <a-form-item>
            <div class="form-text-info"></div>
          </a-form-item>
        </a-col>
        <a-col :span="18" class="submitBtnBox" style="">
          <a-form-item :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
            <a-button type="primary" class="btnMar" @click="getListHandle">
              查询
            </a-button>
            <a-button type="primary" class="btnMar" :disabled="selectedRowKeys.length !== 2" @click="analyseModalFunc">
              执行对比
            </a-button>
            <a-button v-if="mExport" :loading="downloading" type="primary" class="btnMar"
                      @click="openExport">
              导出数据
            </a-button>
            <a-button class="" @click="resetFields">
              清空
            </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-table
        ref="listRef"
        id="table-dom"
        :row-key="row => row.id"
        :loading="loading"
        :columns="columns"
        :data-source="list"
        class="tableBox"
        :pagination="pagination"
        :scroll="{ y, x: 1000 }"
        bordered
        :row-selection="rowSelection"
    >
      <template slot="factoryName" slot-scope="text, record">
        <span style="font-size: 12px">{{ record.factoryName }}</span>
      </template>
      <div slot="typeClassify" slot-scope="text">
        {{ typeObj[text] }}
      </div>
    </a-table>
    <!-- 新增 -->

    <Analyse ref="analyse" class="modalBox" :visible.sync="analyseModal" :ary="ary" :selectedAry="selectedAry"/>
    <!-- 导出 -->
    <ExportConfirm :visible="exportVisible" @close="closeExport" :formData="formData"/>
  </div>
</template>
<script>
import {columns, pagination, columns2} from './config'
import {TpWatermark} from '../utils'

import * as API from './api'
import Analyse from './components/Analyse.vue'
import AnimalSelect from '../MaterialAnalyse/components/AnimalSelect.vue'
import ExportConfirm from './components/ExportConfirm.vue'


export default {
  name: 'NutritionAnalyse',
  props: {
    menuBtnList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    AnimalSelect,
    Analyse,
    ExportConfirm
  },
  mounted() {
    TpWatermark('table-dom', localStorage.getItem('userName') + ' newhope', '150', '450', '-5', 'grey', '50', '0.06')
    this.y = this.$refs.listRef.$el.offsetHeight - 100
    this.form.setFieldsValue({formulaType: '0',isActivate: '1',})
    this.getBtn();
  },
  watch: {},
  data() {
    return {
      y: 380,
      typeList: [],
      factoryList: [],
      staffId: undefined,
      onStaffSearchDebounce: null,
      staffList: [],
      staffFetching: false,
      factoryOptions: [],
      mExport: false,
      exportVisible: false,
      formData: {},
      selectedAry: [],
      form: this.$form.createForm(this, {name: 'EvalueTool'}),
      selectedRowKeys: [], // 新增：存储选中的行键
      selectedRows: [], // 新增：存储选中的完整行数据
      confirmLoading: false,
      analyseModal: false, // 是否显示弹窗
      formItemLayout: {
        labelCol: {span: 7},
        wrapperCol: {span: 17}
      },
      loading: false,
      downloading: false,
      pagination: {
        ...pagination,
        showSizeChanger: true, // 显示每页条数选择器
        pageSizeOptions: ['10', '20','30','40','50', '100'], // 可选的每页条数
        onChange: (current, size) => {
          this.pagination.current = current
          this.getList({current, pageSize: size})
        }, //选择页数
        onShowSizeChange: (current, size) => {
          this.pagination.pageSize = size
          this.pagination.current = 1
          this.getList({current: 1, pageSize: size})
        } //每页多少条
      },
      list: [],
      changedRows: {},
      // columns,
      lineList: [],
      searchList: [],
      columns2,
      noMartial: false,
      ary: [],
      productType: undefined, //
      typeObj: {
        0: '未分类',
        1: '自产配方',
        2: '代工配方',
        3: '定制配方',
      }, // 新增
    }
  },
  computed: {
    editColumns() {
      return this.columns.filter(item => item.editable).map(v => v.dataIndex)
    },
    columns() {
      return this.noMartial ? columns : columns2
    },
    rowSelection() { // 新增：定义 rowSelection 配置
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: this.getCheckboxProps
      };
    },
  },
  created() {
    // this.getList()
    //this.onStaffSearchDebounce = _.debounce(this.onStaffSearch, 600);
   // this.fetchFactoryOptions();
    this.factoryGet()
    this.getTypeList2()
  },
  beforeMount() {
    this.y = window.innerHeight - 400
  },
  methods: {
    getBtn() {
      let factoryId = window.localStorage.getItem('factoryId');
      if (!factoryId) return;
      this.$http.get("/iot-system/menu/buttons", { params: { controlEnd: false, factoryId } }).then(res => {
        let { success, data } = res;
        if (success) {
          data && data.forEach(el => {
            if (el.path === '/fast/ProductNutritionAnalyse') {
              el.children && el.children.forEach(item => {
                if (item.code === 'mExport') this.mExport = true;
              });
            }
          });
        }
      });
    },
    getLineList() {
      let staffId = window.localStorage.getItem('staffId')
      if (!staffId) return
      this.$http.get(`/iot-factory/factorystaffauth/getAnimalIdsInfoByStaffId?StaffId=${staffId}&type=0`).then(data => {
        // let {success,data} = res || {}
        if (data && data.length > 0) {
          data = data.sort((a, b) => a - b)
          let lineList = []
          this.typeList && this.typeList.forEach(el => {
            if (data.includes(el.id)) lineList.push(el)
          })
          this.lineList = lineList
          this.animalRootId = data[0]
          // this.form.setFieldsValue({lineId: data[0] || ''})
          // setTimeout(() => {
          //   this.getList()
          // }, 0);
        }
      })
    },
    inputKeydown(e) {
      if (e.keyCode === 13) this.getList({current: 1, pageSize: 20})
    },
    getSearchList(name) {
      if (name) {
        setTimeout(() => {
          this.placeStr = name || '请输入营养指标名称/代码'
          this.form.setFieldsValue({name})
          this.$get('/nhf-core-data/nutritiontarget/fastNutritionUserPage', {
            current: 1,
            size: 100,
            // factoryId: window.localStorage.getItem('factoryId'),
            searchKey: name
          }).then(res => {
            let {success, data} = res;
            if (success) {
              let {records} = data || {}
              records.map(el => {
                // 使用不区分大小写的正则表达式查找匹配项
                let reg = new RegExp(name, 'i');
                let match = el.name.match(reg);
                if (match) {
                  // 获取匹配项在原字符串中的位置
                  let startIndex = match.index;
                  let endIndex = startIndex + match[0].length;

                  // 按位置分割字符串
                  el.firstName = el.name.substring(0, startIndex);
                  el.midName = el.name.substring(startIndex, endIndex); // 保留原始大小写
                  el.lastName = el.name.substring(endIndex);
                } else {
                  // 无匹配则将整个名称作为 firstName
                  el.firstName = el.name;
                  el.midName = '';
                  el.lastName = '';
                }
                return el;
              })
              this.searchList = records || []
            } else {
              this.searchList = []
            }
          }).catch(() => {
            this.searchList = []
          })
        }, 300);
      }
    },
    onSelect(val) {
      this.selectedList = []
      this.getList({pageSize: this.pagination.pageSize, current: 1, val})
    },
    hasPermission(code) {
      const codes = []
      const fn = ary => {
        ary.forEach(a => {
          codes.push(a.code)
          if (a.children) {
            fn(a.children)
          }
        })
      }
      fn(this.menuBtnList)
      return codes.includes(code)
    },
    async exportFile() {
      const valid = await this.form.validateFields()
      if (!valid) {
        return false
      }
      this.downloading = true
      let {factoryIds = [], ...newdata} = valid
      await API.exportFile({...newdata, factoryIds: factoryIds.join(',')}).catch(e => {
        this.$message.error(e.message)
      })
      this.downloading = false
    },
    disabledFn(row) {
      const limit = 2
      if (this.selectedList.map(v => v.id).indexOf(row.id) !== -1) {
        return false
      }
      // if (this.selectedFormulaCode && this.selectedList.length < limit) {
      //   return row.formulaCode !== this.selectedFormulaCode
      // }
      return this.selectedList.length >= limit
    },
    checkboxChange(e, row) {
      const {checked} = e.target
      if (checked) {
        this.selectedList.push(row)
        // this.selectedFormulaCode = row.formulaCode
      } else {
        this.selectedList = this.selectedList.filter(v => v.id !== row.id)
        // if (this.selectedList.length === 0) {
        // this.selectedFormulaCode = null
        // }
      }
    },
    filterOption(inputValue, option) {
      try {
        return option.componentOptions.children[0].text.indexOf(inputValue) >= 0
      } catch (e) {
        return false
      }
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      setTimeout(() => {
        targetOption.loading = false
        this.getTypeList(targetOption.id, targetOption) || []
      }, 0)
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: this.selectedRowKeys.length >= 2 && !this.selectedRowKeys.includes(record.id),
        },
      };
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      if (selectedRowKeys.length > 2) {
        this.$message.warning('只能选择2行');
        return;
      }
      this.selectedRowKeys = selectedRowKeys;
      // 维护完整的选中行数据
      // 移除已取消选择的行
      this.selectedRows = this.selectedRows.filter(row =>
          selectedRowKeys.includes(row.id)
      );

      // 添加新选择的行（避免重复添加）
      selectedRows.forEach(row => {
        if (!this.selectedRows.some(selectedRow => selectedRow.id === row.id)) {
          this.selectedRows.push(row);
        }
      });
    },
    resetFields() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.form.setFieldsValue({
        formulaType: undefined,
        formulaName: null,
        nutritionIds: undefined,
        animalTypeCode: undefined,
        formulaKeyword: null,
        factoryIds: [],
        staffId: null,
        lineId: undefined,
        productType: '1', // 新增
        typeClassify: undefined,
        pushStatus: undefined,
        pushDateRange: [], // 新增
        createDateRange: [], // 新增
        isPushEbs: undefined // 新增
      })
    },
    refreshTypeList(data) {
      this.getTypeList(data.id, data.targetOption)
    },
    async getListHandle() {
      const valid = await this.form.validateFields()
      if (!valid) {
        return false
      }
      this.selectedList = []
      this.pagination.current = 1
      return this.getList(this.pagination)
    },
    async getList(pagination) {
      const valid = await this.form.validateFields()
      if (!valid) {
        return false
      }
      this.loading = true

      // 新增: 处理推送时间范围
      if (valid.pushDateRange && valid.pushDateRange.length === 2) {
        const customStartTime = '00:00:00'; // 自定义开始时间
        const customEndTime = '23:59:59';   // 自定义结束时间

        valid.pushStartDates = valid.pushDateRange[0].format('YYYY-MM-DD') + ' ' + customStartTime;
        valid.pushEndDates = valid.pushDateRange[1].format('YYYY-MM-DD') + ' ' + customEndTime;
        //去掉时间范围valid时间范围参数，防止向后台传递参数
        delete valid.pushDateRange
      } else {
        valid.pushStartDates = null
        valid.pushEndDates = null
      }

      // 新增: 处理生成时间范围
      if (valid.createDateRange && valid.createDateRange.length === 2) {
        const customStartTime = '00:00:00'; // 自定义开始时间
        const customEndTime = '23:59:59';   // 自定义结束时间

        valid.createStartDates = valid.createDateRange[0].format('YYYY-MM-DD') + ' ' + customStartTime;
        valid.createEndDates = valid.createDateRange[1].format('YYYY-MM-DD') + ' ' + customEndTime;
        //去掉时间范围valid时间范围参数，防止向后台传递参数
        delete valid.createDateRange
      } else {
        valid.createStartDates = null
        valid.createEndDates = null
      }

      let {current = 1, pageSize = 20} = pagination || this.pagination
      let {factoryIds = [], ...newdata} = valid
      let params = {
        factoryIds: factoryIds.join(','),
        ...newdata,
        current,
        requestType: 2,
        size: pageSize,
        startDates: newdata.startDates, // 新增
        endDates: newdata.endDates // 新增
      }
      let feild = 'nutritionGet2'
      if (newdata.nutritionIds) {
        feild = 'nutritionGet'
        this.noMartial = false
      }
      await API[feild](params)
        .then(res => {
          let {success, data} = res
          if (success) {
            let {records = [], current = 1, total = 0, size = 20} = data
            this.list = records
            //将lineId映射为名称
            this.list.map(el => {
              let item = this.lineList.find(el2 => el2.id === el.lineId);
              if(item){
                el.lineName = item.name
              }
              return el
            })
            this.pagination.current = current
            this.pagination.total = total
            this.pagination.pageSize = size
          } else {
            this.$message.error('查询失败')
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
      this.loading = false
    },
    getTypeList2() {
      let params = {
        current: 1,
        size: 10000
      }
      this.$http.get(`/nhf-core-data/line/list`, {params}).then(res => {
        let {success, data} = res
        if (success) {
          let {records} = data || {}
          records && records.map(el => {
            el.value = el.id
            el.label = el.name
            return
          })
          this.typeList = records || []
          this.getLineList()
        }
      })
    },
    getTypeList(parentId = '0', record, type) {
      this.$http.get(`/nhf-core-data/animal/listByParentId?parentId=${parentId}`).then(res => {
        let {success, data = []} = res
        if (success) {
          data &&
          data.map(el => {
            el.value = el.id
            el.label = el.name
            el.isLeaf = !el.hasChildren
            // el.isLeaf = false
            return el
          })
          if (record) {
            // data = [
            //   {name: '测试1',id: '测试1',value: '测试1',label: '测试1',isLeaf: '测试1'}
            // ]
            if (data.length) {
              record.children = data
            } else {
              record.isLeaf = true
            }
            if (!type) {
              this.typeList = [...this.typeList]
            } else {
              this.list = [...this.list]
            }
          } else {
            this.typeList = data
          }
          // this.typeList = data
          // return data
        } else {
          this.typeList = []
        }
        if (type) this.getLineList()
        if (parentId === '0') {
          this.getTypeList(this.typeList[0].id, this.typeList[0], true)
        }
      })
    },
    async factoryGet() {
      let params = {
        current: 1,
        size: 100,
      };
      const res = await this.$http.get("/nhf-app/formulaManage/myFactory", { params })
      let { success, data } = res;
      if (success) {
        let { records} = data;
        this.factoryList = records || [];
      }
    },
    async analyseModalFunc() {
      const valid = await this.form.validateFields();
      let formulaIds = [];
      let flag = true;
      let requestType = 2;
      let { lineId } = valid || {};
      this.selectedAry = [];
      // 修改：使用selectedRows而不是通过ID查找
      this.selectedRows.forEach(row => {
        if (row.nutritionId) flag = false;
        formulaIds.push(row.id);
        this.selectedAry.push({
          factoryName: row.factoryName,
          productName: row.productName,
          productCode: row.productCode,
          version: row.version,
        });
      });
      if (flag) {
        await API.nutritionGet({
          formulaIds: formulaIds.join(','), lineId, requestType,
          current: 1, size: 5000
        }).then(res => {
          let { success, data } = res;
          if (success) {
            let { records } = data || {};
            this.ary = records || [];
            setTimeout(() => {
              this.analyseModal = !this.analyseModal;
            }, 0);
          }
        })
      } else {
        // 修改：直接使用selectedRows
        this.ary = this.selectedRows;
        setTimeout(() => {
          this.analyseModal = !this.analyseModal;
        }, 0);
      }
    },
    async onStaffSearch(value) {
      this.staffFetching = true;
      const res = await this.$post("/iot-user/userShortInfoListPage", {query: {size: 1000, current: 1,}, name: value});
      if (res.data && res.data?.records) {
        this.staffList = res.data.records;
      }
      this.staffFetching = false;
    },
    onStaffChange(value) {
      this.form.setFieldsValue({staffId: value});
    },
    async fetchFactoryOptions() {
      try {
        let staffIdTmp = window.localStorage.getItem('staffId')
        if (!staffIdTmp) return// 这里可以动态获取 staffId
        const res = await this.$http.get(`/iot-factory/factorystaffauth/deptAuthTree?staffId=${staffIdTmp}`);
        if (res.data && res.data.length > 0) {
          // console.log('Fetched factory options:', res.data); // 调试信息
          // 处理数据，确保每个节点的 factoryId 唯一且不为 null
          const processTreeData = (data) => {
            return data
                .map(node => {
                  if (!node.factoryId) {
                    // console.warn('Node with missing factoryId:', node);
                  }
                  const processedChildren = node.children ? processTreeData(node.children) : [];
                  // 如果 children 为空数组且 lineIds 为空字符串，则返回 null
                  if (processedChildren.length === 0 && node.lineIds.length === 0) {
                    return null;
                  }
                  return {
                    ...node,
                    factoryId: node.factoryId || `default-${node.deptName}-${node.id}`, // 设置默认值或唯一标识
                    children: processedChildren
                  };
                })
                .filter(node => node !== null); // 过滤掉 null 值
          };
          this.factoryOptions = processTreeData(res.data);
        } else {
          this.factoryOptions = [];
        }
      } catch (error) {
        console.error('获取工厂选项失败', error);
        this.factoryOptions = [];
      }
    },
    onFactoryChange(value) {
      console.log('选中的工厂ID:', value);
      // 更新表单值
      this.form.setFieldsValue({factoryId: value});
      // 执行其他操作
    },
    openExport() {
      this.formData = this.form.getFieldsValue();
      //如果营养指标列表为空，则提示导出必须有原料
      // if(this.formData.nutritionIds === undefined){
      //   this.$message.error('导出营养指标列表为空，请先添加营养指标');
      //   return;
      // }
      this.exportVisible = true;
    },
    closeExport() {
      this.exportVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.listContent {
  // height: calc(100% - 36px);
  .tableBox {
    height: calc(100% - 165px);
    min-height: 240px;
  }
}

#table-dom {
  position: relative;
}

::v-deep .ant-table-thead > tr > th {
  padding: 0px;
}
</style>

<style lang="scss">
#listContent .ant-form {
  max-width: none;
}

#listContent .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.ant-advanced-search-form {
  padding: 10px 20px;
  margin-bottom: 20px;
  background: #fff;
  // border: 1px solid #d9d9d9;
  border-radius: 6px;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#listContent {
  .ant-form-explain {
    position: absolute;
  }
}
</style>
